export default __webpack_public_path__ + "static/media/812.0f26e27d.png";